import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ExamService } from '../services/exam.service';
import { ProctoringService } from '../services/proctoring.service';
import { UserauthenticationserviceService } from '../services/userauthenticationservice.service';

import { environment } from 'src/environments/environment';
import { QuestionserviceService } from '../services/questionservice.service';
import { CbtserviceService } from '../services/cbtservice.service';
import { ExamfeedbackComponent } from '../examfeedback/examfeedback.component';
import { CurrentUser } from '../models/CurrentUser';
import { ExamDetails, ExamInfo } from '../models/Exam';
import { LanguageService } from '../services/language.service';
@Component({
  selector: 'app-submit',
  templateUrl: './submit.component.html',
  styleUrls: ['./submit.component.css']
})
export class SubmitComponent implements OnInit {
  examno: string;
  thisurl = location.origin + '/';
  score: any;
  examination: ExamDetails;
  onblurfunction;
  onfocusfunction;
  countdown: any;
  lossactionmsg: string = "";
  losscount: number = 0;
  focuslosswarningmessage: string = ""
  lostfocus: boolean = false
  examid: number;
  constructor(public activatedroute: ActivatedRoute, public userauth: UserauthenticationserviceService, public router: Router, public examservice: ExamService, public toastr: ToastrService,public questionservice:QuestionserviceService, private proctorservice: ProctoringService, private cbtservice: CbtserviceService, private languageService: LanguageService) { }
  scheduleid: any
  msg: any
  postmsg: any
  isloading: boolean = false;
  submitting: boolean = false;
  marking: boolean = false;
  scoreFetchError: boolean = false;
  linkedExams: ExamInfo[];

  @ViewChild('feedmodal') private feedmodal: ExamfeedbackComponent;
  canGoBack: boolean = true;
  get language(){
    return this.languageService.language;
  }

  async ngOnInit() {
    this.scheduleid = this.activatedroute.snapshot.queryParams.scheduleid
    this.examid = this.activatedroute.snapshot.queryParams.examid
    this.isloading = true;

    try {
      const user: CurrentUser = await this.userauth.getCurrentUser();
      if (user) {
        this.examno = user.username;
      }
      else if (this.userauth.getCurrentUserToken()) {
        this.userauth.userLogout();
      }
      if (!this.activatedroute.snapshot.queryParams.url) {
        await this.proctorservice.stopProctor('Submit Page Init');
        this.isloading = true;
        const response: any = await this.examservice.submit(this.scheduleid, false,this.examid);
        this.msg = response?.statusmsg;
        this.score = response?.score
        this.postmsg = response?.postmsg;

      }
      this.examination = await this.examservice.getexamwithscheduleid(this.scheduleid,this.examid);

      if (this.examination.checkfocusloss && !this.onblurfunction && !this.msg/* && admintestlogin != "True"*/) {
        this.onblurfunction = this.onBlur.bind(this);//have to do it this way because if i just set the event listener to this.setTileSize, the "this" becomes window
        this.onfocusfunction = this.onFocus.bind(this);
        window.addEventListener('focus', this.onfocusfunction);
        window.addEventListener('blur', this.onblurfunction);
      }
      const data = JSON.parse(localStorage.getItem(`${this.scheduleid}_post_finish_data`));
      if (data) {
        this.msg = data.msg;
        this.score = data.score;
        this.postmsg = data.postmsg;
        this.canGoBack = false;
      }

      if (this.msg) {
        this.getuserexams(this.examno, this.examination.examid);
      }
      this.isloading = false;
    }
    catch (error) {
      console.error(error);
      this.cbtservice.showHttpError(error);
      this.isloading = false;
    }
  }

  noclicked() {
    //this.questionservice.previousquestiondata = null;
    //this.questionservice.nextquestiondata = null;
    if (this.activatedroute.snapshot.queryParams.url) {
      this.router.navigateByUrl(this.activatedroute.snapshot.queryParams.url);
    }

    else {
      this.router.navigate(['/exam/question'], { queryParams: { scheduleid: this.scheduleid, questionno: 1, examid: this.examination.examid } });
    }
  }

  async yesclicked() {
    this.feedmodal.open();
    try {
      this.submitting = true;

      const response: any = await this.examservice.submitexam(this.scheduleid, this.examination.liteMode,this.examid);
      if (response.statusmsg) {
        this.questionservice.clearQuestionStorage();
      }
      await this.proctorservice.stopProctor('Exam Submit Clicked');
      
      this.msg = response.statusmsg;
      this.score = response.score
      this.postmsg = response.postmsg;
      this.canGoBack = false;
      let result = { msg: this.msg, score: this.score, postmsg: this.postmsg };
      localStorage.setItem(`${this.scheduleid}_post_finish_data`,JSON.stringify( result));

      // Poll for exam score if it's MCQ and allowed to see score after exam
      if (this.examination.showscorewhenfinished) {        
        this.marking = true;
        let interval = 1000; // Start with 1 second
        const pollingCap = 20*1000; // Cap at 20 seconds

        const checkScore = async () => {
            const startTime = Date.now();
            const timeoutDuration = 1*60*60*1000; // 1 hour in milliseconds

            try {
              if (Date.now() - startTime >= timeoutDuration) {
                this.marking = false;
                this.scoreFetchError = true;
                return;
              }

              const scoreData = await this.examservice.getCandidateExamScore(this.scheduleid, this.examid);

              if (scoreData.isscored && !scoreData.ispending) {
                this.score = `${scoreData.score}/${scoreData.totalObtainable}`;
                this.marking = false;
                return;
              }

              // Increase interval exponentially but continue polling
              interval = Math.min(interval * 2, pollingCap);
              
            } catch (error) {
              console.error('Error checking score:', error);
              
              // Continue polling even on error, could be network issues
              interval = Math.min(interval * 2, pollingCap);
            }
            finally {
              if (this.marking) {
                setTimeout(checkScore, interval);
              }
            }
        };
       
        // Start polling
        checkScore();
      }

      this.getuserexams(this.examno, this.examination.examid);
    }
    catch(err){
      this.cbtservice.showHttpError(err);
    }
    finally {
      this.submitting = false;
    }
  }

  async getuserexams(candidateno: string, examid: number) {
    this.isloading = true;
    this.linkedExams = await this.examservice
      .getuserlinkedexams(candidateno, examid)
      .catch((err) => this.cbtservice.showHttpError(err))
      .finally(() => (this.isloading = false));

    this.linkedExams.forEach((exam: ExamInfo) => {
      console.log(JSON.stringify(exam))
      if (exam.useCaptcha && exam.canstart) {
        //if there is any exam using captcha, just load captcha early
        this.questionservice.loadCaptchaAndWaitForReadiness();
      }
    })
  }

  // @OnPageVisibilityChange()
  // logWhenPageVisibilityChange(visibilityState: AngularPageVisibilityStateEnum): void {
  //   if (AngularPageVisibilityStateEnum[visibilityState]
  //     === AngularPageVisibilityStateEnum[AngularPageVisibilityStateEnum.HIDDEN] && this.msg) {
  //     console.log('OnPageVisibilityChange => hidden');
  //   }
  // }

  newexam() {
    window.location.href = `${this.thisurl}exam/userexams`;
  }

  ngOnDestroy(): void {
    if (this.onblurfunction) {
      window.removeEventListener('focus', this.onfocusfunction);
      window.removeEventListener('blur', this.onblurfunction);
    }
    window.onpopstate = null;
  }

  onFocus() {
    clearTimeout(this.countdown);
    console.log('OnPageVisibilityChange => visible');
    if (this.lostfocus && this.focuslosswarningmessage != '') {
      this.toastr.warning(this.focuslosswarningmessage);
    }
  };

  onBlur() {
    if (this.examination.checkfocusloss && !this.proctorservice.chatopened) {
      let audio = new Audio();
      audio.src = "/assets/beep.mp3";
      audio.loop = false;
      audio.load();
      audio.play();
      console.log("audio played");
      const mythis = this;
      this.countdown = setTimeout(() => {
        //debugger;
        if (!mythis.proctorservice.chatopened) {
          this.setres();
        }
        // if ((this.examination.nooffocusloss - this.losscount) === 1) {
        //   audio.play();
        //   console.log("audio played")
        // }
      }, 1000 * this.examination.durationofloss);
    }
  }
  gotoComplaint() {
    window.location.href = `${this.thisurl}complaint`;
  }
  async setres() {
    var data: any = await this.examservice.setfocuslosscounter(this.scheduleid,this.examid).catch(err => this.cbtservice.showHttpError(err));
    this.losscount = data.flcount;
    clearTimeout(this.countdown);
    if (this.losscount > this.examination.nooffocusloss) {
      var data2: any = await this.examservice.performfocuslossaction(this.scheduleid,this.examid).catch(err => this.cbtservice.showHttpError(err));

      if (data2.msg == "ReduceTIme" && this.examination.focuspenalty == "ReduceTIme") {
        this.toastr.warning(`${this.language.youHaveLost} ${this.examination.reducetimelossduration} ${this.language.leavingExamPage}`);
      }
      if (/*data2.msg &&*/ data2.msg != "ReduceTIme") {
        // window.location.href = `${this.thisurl}exam/submit?scheduleid=${this.scheduleid}`;
        this.router.navigate(['/exam/submit'], { queryParams: { scheduleid: this.scheduleid, examid: this.examid } });
      }
    }
    else {
      this.focuslosswarningmessage = this.language.penalizedWarning;
      this.lostfocus = true
      this.toastr.warning(this.focuslosswarningmessage);

    }
  }
 @HostListener('window:popstate', ['$event'])
  onPopState(event: Event): void {
  if (!this.canGoBack) {
    window.location.href = this.thisurl + 'exam/userexams';
  }
}

}
